import React from 'react';
import { motion } from 'framer-motion';
export function IntegrationsSection() {
  const logos = [{
    name: 'Boats Group',
    url: 'https://cdn.magicpatterns.com/uploads/hhqMeZ9Y3b4gv3VACLTvXC/boats-group-logo.png.webp'
  }, {
    name: 'DockMaster',
    url: 'https://cdn.magicpatterns.com/uploads/89dQKb9XThNoGMaDWGJmCn/dockmaster-logo.png.webp'
  }, {
    name: 'Digital Power Solutions',
    url: 'https://cdn.magicpatterns.com/uploads/vkaEPWkaXT1V6DpkEiZUUZ/digital-power-solutions-logo.png.webp'
  }, {
    name: 'HubSpot',
    url: 'https://cdn.magicpatterns.com/uploads/wxYF5sCwYaJeNKcZnn9ZBX/hubspot-logo.png.webp'
  }, {
    name: 'Kenect',
    url: 'https://cdn.magicpatterns.com/uploads/uj1tokH1W9gwPFszc56Wwd/kenect-logo.png.webp'
  }, {
    name: 'Lightspeed',
    url: 'https://cdn.magicpatterns.com/uploads/2X9twuHPT9HiukE2Jphhbi/lightspeed-logo.png.webp'
  }, {
    name: 'Salesforce',
    url: 'https://cdn.magicpatterns.com/uploads/3WcLTCw4Au3TjP5jsMD1Da/salesforce-logo.png.webp'
  }];
  return <section className="py-16 bg-gray-50 border-y border-gray-200" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-112">
        <h2 className="text-2xl md:text-3xl font-bold text-[#0A2540] mb-6" data-id="element-113">
          Seamless Integrations
        </h2>
        <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-114">
          We can integrate with any dealer management system to automate your
          listing management.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 max-w-5xl mx-auto" data-id="element-115">
          {logos.map((logo, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="h-20 w-[180px] bg-white rounded-lg shadow-sm border border-gray-200 flex items-center justify-center p-6 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-116">
              <img src={logo.url} alt={`${logo.name} logo`} className="max-w-full max-h-full object-contain" data-id="element-117" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}